<template>
  <a-radio-group :options="options" :value="value" @change="handleChange" />
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    item: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  watch: {
    item: {
      async handler(val) {
        const res = await this.axios.get(
          "/common/dict/item?code=" + val.dictCode
        );
        this.options = res.result.map(item => ({
          value: item.itemValue,
          label: item.itemText
        }));
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      options: []
    };
  },
  methods: {
    handleChange(e) {
      //   console.log(e);
      //   this.$emit("input", e);
      this.$emit("change", e);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/common/components/dictRadio.vue